/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Engagement_DescriptionInputs */

const en_marketing_engagement_description = /** @type {(inputs: Marketing_Engagement_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JXD builds your product on Onyx.`)
};

const es_marketing_engagement_description = /** @type {(inputs: Marketing_Engagement_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JXD construye tu producto sobre Onyx.`)
};

const fr_marketing_engagement_description = /** @type {(inputs: Marketing_Engagement_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JXD construit votre produit sur Onyx.`)
};

/**
* | output |
* | --- |
* | "JXD builds your product on Onyx." |
*
* @param {Marketing_Engagement_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_engagement_description = /** @type {((inputs?: Marketing_Engagement_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Engagement_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_engagement_description(inputs)
	if (locale === "es") return es_marketing_engagement_description(inputs)
	return fr_marketing_engagement_description(inputs)
});